/**
 * @deprecated Prefer `SessionAccessTypeFlag`. A session may hold multiple types of access.
 */
export enum AccessType {
    Self = 0,
    AdminAccess = 1,
    EmergencyAccess = 2,
    Msp = 3,
}
